<div class="container-fluid">
<div class ="row">
    <div class="col-md-12 col-sm-12 col-xs-12 ">
        <h1 class="header">{{productCategoryName}}</h1>
    </div>

</div>

    <!-- Sorting Dropdown -->
    <div class=" row">
        <div class="product-grid2">
            <div class="col-md-12 col-xs-12 col-xl-12 col-sm-12 col-lg-12">
                <div class="col-md-8  col-xl-8  col-lg-8">
                </div>
                <div class=" col-md-2 col-xs-7 col-xl-2 col-sm-7 col-lg-2">
                    <p class="number-product"> {{productCount}} products in {{productCategoryName}} : </p>
                </div>
                <div class=" col-md-2 col-xs-5 col-xl-2 col-sm-5 col-lg-2">
                    <p class=" sorter">Sort By</p>
                    <mat-form-field>
                        <!-- <mat-label>Select to sort</mat-label> -->
                        <mat-select (selectionChange)="getSortedProducts($event.value)" [(value)]="selected">
                            <mat-option *ngFor="let sorter of sortingList" [value]="sorter.viewValue">
                                {{sorter.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
    <hr><br>

    <!-- -----Section for Filters------ -->
    <div class="row ">
        <div class="col-md-3 col-sm-12  col-xl-3 col-xs-12 col-lg-3">
            <div class="product-grid2">
                <p class="filter">Filter By</p>
                <hr><br>
                <!-- Dynamic Filter Attributes -->
                
                <ng-container *ngFor="let filters of filterList">
                    <mat-expansion-panel [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                {{filters.categoryAttributeName}}
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div *ngFor="let values of filters.categoryAttributeValues ;let i=index">
                            <mat-checkbox class="breakLine" [checked]="values.isIncluded" [value]="values.isIncluded"
                                (change)="filter($event,values)">
                                {{values.attributeValue}}<br />
                            </mat-checkbox>
                        </div> <br>
                    </mat-expansion-panel>
                </ng-container>
           
            </div>
        </div>
        <!-- Dynamic Product Grid  -->

        <div class="col-md-9 col-sm-12 col-xl-9 col-lg-9 col-xs-12  ">
            <ng-container *ngFor="let product of finalProduct;let i=index; ">
                <div class="col-md-4 col-sm-12 col-xl-4" *ngIf="product.isSelected==true">
                    <div class="product-grid2">
                        <div class="product-image2">
                            <div routerLink="/product/{{product.productId}}">
                                <img class="pic-1" [src]="product.mainImage">
                                <img class="pic-2" [src]="product.hoverImage">
                            </div>
                            <ul class="social">
                                <li><a href="#" data-tip="Quick View" routerLink="/product/{{product.productId}}"><i
                                            class="fa fa-eye"></i></a></li>
                            </ul>
                            <a class="add-to-cart" routerLink="/product/{{product.productId}}">View Details</a>
                        </div>
                        <div class="product-content">
                            <h3 class="title"><a routerLink="/product/{{product.productId}}">{{product.productName}}</a>
                            </h3>
                            <span class="price">{{product.price}}</span>
                        </div>
                    </div>
                </div>

            </ng-container>
        </div>


    </div>
</div>